import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import ReactNumberFormat from "react-number-format";
import { Row, Col, Button } from "reactstrap";
import { toast } from "react-toastify";
import qs from "query-string";
import * as routines from "modules/User/routines";

import * as timeHelpers from "helpers/time";
import * as variables from "constants/variables";
import { template } from "lodash";

export interface SubscriptionProps {
  approved_at?: string;
  course_id?: number;
  order_id: number;
  course_name?: string;
  created_at?: string;
}

const TRANSLATION_BASE = "modules.subscription";

export default ({
  approved_at,
  order_id,
  course_id,
  course_name,
  created_at
}: SubscriptionProps) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const date = new Date(new Date().setFullYear(new Date().getFullYear() + 1)).toISOString().substr(0, 19).replace('T', ' ');
  const approveOrder = (values:any, order:any) => {
    values = {"is_approved": true, "expires_at": date};
    order = order_id;
    dispatch(
      routines.approve({
        order, values,
        onSuccess: () => {
          toast.success(t("global.notification.success"), { position: toast.POSITION.TOP_RIGHT });
          window.open(window.location['href'], "_self");
        },
        onError: (error = {}) => {
          toast.error(error, { position: toast.POSITION.TOP_RIGHT });
        }
      })
    )
  }

  const renderPrice = (value: number | string) => (
    <ReactNumberFormat value={value} displayType="text" thousandSeparator=" " />
  );

  return (
    <div className="card-box mb-2" style={{ position: "relative" }}>
      <Row className="align-items-center">
        <Col sm={10}>
          <div className="media">
            <div className="media-body">
              {course_id && (
                <h4 className="mt-0 mb-1 font-16">
                  <b>{t(`${TRANSLATION_BASE}.course`)}:</b> {course_name}
                </h4>
              )}
              <b>{t(`${TRANSLATION_BASE}.order_date`)}:</b> <span className="badge badge-info">{timeHelpers.formatDate(created_at)}</span>
            </div>
          </div>
        </Col>
        {approved_at === null ? <Col sm={2}><Button onClick={() => approveOrder(date, order_id)}>Одобрить</Button></Col> : ''}
      </Row>
    </div>
  );
};
